/**
 * Dependencies
 */
import Vue from 'vue'
import { getState } from './state'

/**
 * Attempt the login process, set the pending state
 *
 * @param  {Object} state
 * @return {Void}
 */
const LOGIN = (state) => {
    state.pending = true
}

/**
 * Set the login states after a successful authentication
 *
 * @param  {Object} state
 * @return {Void}
 */
const LOGIN_SUCCESS = (state) => {
    state.isLoggedIn = true
    state.pending = false
}

/**
 * Set successful login state
 *
 * @param  {Object} state
 * @return {Void}
 */
const FINISHED = (state) => {
    state.isLoggedIn = true
}

/**
 * Handle the failed login attempt
 *
 * @param  {Object} state
 * @return {Void}
 */
const LOGIN_FAILURE = (state) => {
    state.pending = false
}

/**
 * Set the logged in status on successful log out
 *
 * @param  {Object} state
 * @return {Void}
 */
const LOGOUT = (state) => {
    state.isLoggedIn = false
}

/**
 * Set up the user profile
 *
 * @param  {Object} state
 * @param  {Object} profile
 * @return {Void}
 */
const SET_USER_PROFILE = (state, profile) => {
    state.profile.data = profile
    state.profile.loaded = true
    state.profile.pending = false
}

/**
 * Set profile request state
 *
 * @param  {Object} state
 * @return {Void}
 */
const GET_USER_PROFILE = (state) => {
    state.profile.pending = true
}

/**
 * Handle profile retrieval failure
 *
 * @param  {Object} state
 * @return {Void}
 */
const GET_USER_PROFILE_FAIL = (state, err) => {
    console.log(err)
    state.profile.pending = false
}

/**
 * Reset the state
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_STATE = (state) => {
    let originalState = getState()
    for (let prop in originalState) {
        Vue.set(state, prop, originalState[prop])
    }
}

/**
 * Set the first run state attribute
 *
 * @param  {Object} state
 * @return {Void}
 */
const SET_FIRST_RUN = (state) => {
    state.first_run = true
}

/**
 * Reset the first run state attribute
 *
 * @param  {Object} state
 * @return {Void}
 */
const RESET_FIRST_RUN = (state) => {
    state.first_run = false
}

/**
 * Export Mutations
 */
export default {
    LOGIN,
    LOGOUT,
    FINISHED,
    RESET_STATE,
    LOGIN_SUCCESS,
    LOGIN_FAILURE,
    SET_FIRST_RUN,
    RESET_FIRST_RUN,
    GET_USER_PROFILE,
    SET_USER_PROFILE,
    GET_USER_PROFILE_FAIL
}



// WEBPACK FOOTER //
// ./src/state/modules/user/mutations.js